<script setup>
import Width from "@/pages/Index/Width.vue";
import {ref} from "vue";
import SvgIcon from "@/components/SvgIcon/SvgIcon.vue";

const slogans = ref([
	{
		label: 'section.tags.win',
		icon: 'cooperation'
	},
	{
		label: 'section.tags.benefitingAll',
		icon: 'benefitingAll'
	},
	{
		label: 'section.tags.honesty',
		icon: 'honesty'
	},
	{
		label: 'section.tags.brandValue',
		icon: 'brand-value'
	}
])
</script>

<template>
	<div class="slogan">
		<Width>
			<el-row
				type="flex"
				justify="center"
				align="middle"
			>
				<el-col
					:xs="12"
					:sm="6"
					:md="6"
					:lg="6"
					:xl="6"
					v-for="(item, index) in slogans"
				>
					<div class="slogan__warp">
						<div>
							<SvgIcon :name="item.icon" class-name="slogan__icon" />
						</div>
						<div class="slogan__title">{{ $t(item.label) }}</div>
					</div>
				</el-col>
			</el-row>
		</Width>
	</div>
</template>

<style scoped lang="less">
.slogan {
	padding: 50px 0;
	background-color: #fff;
	
	&__warp {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	&__icon {
		width: 32px;
		height: 32px;
	}
	
	&__title {
		margin-left: 10px;
		font-size: 24px;
		font-weight: bold;
	}
	
}

@media only screen and (max-width: 768px) {
	.slogan {
		display: none;
		padding: 20px 0 0 0;
		
		&__warp {
			margin-bottom: 20px;
		}
	}
}

@media only screen and (max-width: 535px) {
	.slogan {
		
		&__icon {
			width: 20px;
			height: 20px;
		}
		
		&__title {
			font-size: 18px;
			margin-left: 5px;
		}
	}
}
</style>